import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { ExtensionComponent } from './extension/extension.component';
import { RouterModule } from '@angular/router';
import { widgetRoutes } from './widget.routes';
import { WidgetComponent } from './widget.component';
import { DownloadWidgetComponent } from './download-widget/download-widget.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    TranslateModule,
    NgxPermissionsModule,
    RouterModule.forRoot(widgetRoutes)
  ],
  providers: [],
  declarations: [WidgetComponent, ExtensionComponent, DownloadWidgetComponent],
  exports: [DownloadWidgetComponent],
  entryComponents: []
})
export class WidgetModule {}
